import React, {useRef} from 'react';
import cl from '../BaseSimplePage/BaseSimpleItemEditor.module.css'
import {Alert} from "@mui/material";
import SurveysItemForm from "./SurveysItemForm";

const SurveysSummaryEditor = ({
                                    surveyData,
                                    summaryData,
                                }) => {

    const formControlRef = useRef(null);

    return (
        <div className={cl.main}>
            {/*<SurveysItemEditorHeader
                editItemId={12345}
            />*/}
            <div className={cl.scrollContent}>

                {summaryData && !Boolean(summaryData.total_responses) && <Alert severity={"info"}>Поиск не дал результатов</Alert>}
                {summaryData && Boolean(summaryData.total_responses) && <SurveysItemForm
                    surveyData={surveyData}
                    initData={summaryData}
                    summaryMode={true}
                    controlRef={formControlRef}
                    pageOptions={{}}
                />}
            </div>
        </div>
    );
};

export default SurveysSummaryEditor;